import { atom, selector, useRecoilState, useRecoilValue } from 'recoil';
import {
  IncidentOwnershipFilter,
  IncidentUrgencyFilter,
  IncidentMetadataFilter,
} from 'hooks/useMapSearch';

export type IncidentFiltersState = {
  ownership: IncidentOwnershipFilter | null;
  urgency: IncidentUrgencyFilter[];
  metadata: IncidentMetadataFilter[];
};

export const DEFAULT_INCIDENT_FILTERS_STATE: IncidentFiltersState = {
  ownership: null,
  urgency: [],
  metadata: [],
};

const incidentFiltersStateAtom = atom({
  key: 'INCIDENT_FILTERS_STATE',
  default: DEFAULT_INCIDENT_FILTERS_STATE,
});

const incidentFiltersCountSelector = selector({
  key: 'INCIDENT_FILTERS_COUNT',
  get: ({ get }) => {
    const filters = get(incidentFiltersStateAtom);
    return (
      (filters.ownership ? 1 : 0) +
      filters.urgency.length +
      filters.metadata.length
    );
  },
});

export type UseIncidentFiltersState = {
  filters: IncidentFiltersState;
  setFilters: (
    valOrUpdater:
      | IncidentFiltersState
      | ((currVal: IncidentFiltersState) => IncidentFiltersState),
  ) => void;
  filtersCount: number;
};

export const useIncidentFiltersState = (): UseIncidentFiltersState => {
  const [filters, setFilters] = useRecoilState(incidentFiltersStateAtom);
  const filtersCount = useRecoilValue(incidentFiltersCountSelector);

  return {
    filters,
    setFilters,
    filtersCount,
  };
};

export const useIncidentFiltersCount = (): number => {
  return useRecoilValue(incidentFiltersCountSelector);
};
